import { 
    GET_HRADMIN_EMPLOYEE_LIST_SUCCESS,
    GET_HRADMIN_EMPLOYEE_CLAIMS_LIST_SUCCESS,
    GET_HRADMIN_EMPLOYEE_OUTPATIENT_CLAIM_DATA_SUCCESS,
    GET_HRADMIN_EMPLOYEE_INPATIENT_CLAIM_DATA_SUCCESS,
    GET_HRADMIN_MHC_INSIGHTS_URL_SUCCESS,
} from '../actions';

const initialState = {
    employeelistData: [],
    employeeClaimsList: [],
    selectedEmployeeToView: null,
    employeeClaimData: null,
    selectedClaimToView: null,
    mhcInsightsUrl: null,
};

export default function(state = initialState, action) {
    switch(action.type) {
        case GET_HRADMIN_MHC_INSIGHTS_URL_SUCCESS:
            return Object.assign({}, state, { mhcInsightsUrl: action.payload.data.redirect_url });
        case GET_HRADMIN_EMPLOYEE_LIST_SUCCESS:
            return Object.assign({}, state, { employeelistData: action.payload.data.employees });
        case GET_HRADMIN_EMPLOYEE_CLAIMS_LIST_SUCCESS:
            return Object.assign({}, state, { 
                employeeClaimsList: action.payload.response.data.claims, 
                selectedEmployeeToView: action.payload.selectedUserId, 
            });
        case GET_HRADMIN_EMPLOYEE_OUTPATIENT_CLAIM_DATA_SUCCESS:
            return Object.assign({}, state, { 
                employeeClaimData: action.payload.response.data.claim, 
                selectedEmployeeToView: action.payload.selectedUserId, 
                selectedClaimToView: action.payload.selectedClaimToView,
            });
        case GET_HRADMIN_EMPLOYEE_INPATIENT_CLAIM_DATA_SUCCESS:
            return Object.assign({}, state, { 
                employeeClaimData: action.payload.response.data.claim, 
                selectedEmployeeToView: action.payload.selectedUserId, 
                selectedClaimToView: action.payload.selectedClaimToView,
            });
        default:
            return state;
    }
}